import React, {FC} from "react";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import {Tooltip} from "@material-ui/core";
import useStyles from "./styles";

type Props = {status: string};

const UnpublishedStatus: FC<Props> = ({status}) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      {status}
      <Tooltip title="Task unpublished" placement="bottom-start">
        <VisibilityOffIcon className={classes.icon} />
      </Tooltip>
    </div>
  );
};

export default UnpublishedStatus;
